	<featured-contest [contest]="displayedContest"></featured-contest>
